import type { KYCDocumentUploadType } from "./api-types/base_schemas";
import type { SupportedCountry } from "./components/interface";
// This is almost the same as the Record<K,T>, but it can be used if you have optional keys (<K>) that are passed as the first argument to the generic
export type PartialRecord<K extends keyof any, T> = {
  [P in K]?: T;
};

export type CountryMap = Record<SupportedCountry, string>;

export type JurisdictionalLabelGetter = (country: SupportedCountry) => string;

export type IdvSimpleStatus = "not_started" | "not_verified" | "verified" | "failed" | "fraud";

export enum SignerSubRoleEnum {
  DIRECTOR = "director",
  SECRETARY = "secretary",
  POWER_OF_ATTORNEY = "power_of_attorney",
  NONE = "none",
}

export const KYCDocumentUploadTypes: Record<string, KYCDocumentUploadType> = {
  COMPANY_FORMATION_DOCUMENT: "company_formation_document",
  COMPANY_PROOF_OF_ADDRESS: "company_proof_of_address",
  COMPANY_CONNECTION_BETWEEN_LEGAL_ENTITY_AND_BRAND: "company_connection_between_legal_entity_and_brand",
  COMPANY_MISSING_FROM_HANDELS_REGISTER: "company_missing_from_handels_register",
  COMPANY_LEGAL_PROCEEDINGS_CLARIFICATION: "company_legal_proceedings_clarification",
  COMPANY_REGISTRY_STATUS_CLARIFICATION: "company_registry_status_clarification",
  COMPANY_TRADING_HISTORY_CLARIFICATION: "company_trading_history_clarification",
  COMPANY_EMPLOYER_IDENTIFICATION_NUMBER_CONFIRMATION: "company_employer_identification_number_confirmation",
  PERSON_PROOF_OF_ADDRESS: "person_proof_of_address",
  PERSON_PASSPORT: "person_passport",
  PERSON_ID_DOCUMENT: "person_id_document",
  PERSON_SOCIAL_SECURITY_CARD: "person_social_security_card",
  GENERIC_DOCUMENT: "generic_document",
  STAFF_UPLOADED_DOCUMENT: "staff_uploaded_document",
};
